import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateDeskRequest extends BaseUpdateRequest {
    name = '';
    businessHoursId = '';
}